/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    /* Components */
    export const NETWORK_NODES_COMPONENT: string = "networkNodes";
    export const FLEXO_COMPONENT: string = "flexo";
    export const NODE_HEALTH_COMPONENT: string = "nodeHealth";
    export const CONNECTION_ROOM_COMPONENT: string = "connRoom";
    export const MOBILE_DATA_COMPONENT: string = "mobileData";
    export const ALARMS_COMPONENT: string = "alarms";
    export const WATCHDOG_COMPONENT: string = "watchdog";
    export const FLEXAUTH_COMPONENT: string = "auth";
    export const SON_ADAPTER_COMPONENT: string = "sonadapter";

    /* Common operations */
    export const ALL_OPERATIONS: string = "*";
    export const SAVE_OPERATION: string = "save";
    export const CREATE_OPERATION: string = "create";
    export const DELETE_OPERATION: string = "delete";

    /* NetworkNode operations */ 
    export const CREATE_NETWORK_NODE_OPERATION: string = "createNetworkNode"; 
    export const SAVE_NETWORK_NODE_OPERATION: string = "saveNetworkNode"; 
    export const DELETE_NETWORK_NODE_OPERATION: string = "deleteNetworkNode"; 
    export const CREATE_INVENTORY_BUNDLE_OPERATION: string = "createInventoryBundle";
    export const CREATE_GATEWAY_OPERATION: string = "createGateway";
    export const SAVE_GATEWAY_OPERATION: string = "saveGateway"; 
    export const DELETE_GATEWAY_OPERATION: string = "deleteGateway"; 
    export const CREATE_NETWORK_OPERATION: string = "createdNetwork"; 
    export const SAVE_NETWORK_OPERATION: string = "savedNetwork"; 
    export const DELETE_NETWORK_OPERATION: string = "deletedNetwork";
    export const START_SUPPORT_TEST_OPERATION: string = "startSupportTest";
    export const END_SUPPORT_TEST_OPERATION: string = "endSupportTest"; 
    export const CREATE_LINK_OPERATION: string = "createdLink";
    export const DELETE_LINK_OPERATION: string = "deletedLink"; 
    export const CREATE_PROBE_OPERATION: string = "createProbe";
    export const SAVE_PROBE_OPERATION: string = "saveProbe";
    export const DELETE_PROBE_OPERATION: string = "deleteProbe";
    export const TOPOLOGY_ELEMENT_PLACED_OPERATION: string = "topologyElementPlaced";
    export const WORKFLOW_CHANGED_OPERATION: string = "workflowChanged";
    export const WORKFLOW_MODE_MAINTENANCE: string = "maintenance";
    export const WORKFLOW_MODE_OPERATION: string = "operation";
    export const DEVICE_CREDENTIALS_CHANGED: string = "deviceCredentialsChanged";
    export const NETWORK_NODE_ORGANIZATION_CHANGED_OPERATION: string = "networkNodeOrganizationChangeOperation";
    export const NETWORK_NODE_ORGANIZATION_ADDED_OPERATION: string = "networkNodeOrganizationAddOperation";
    export const NETWORK_NODE_ORGANIZATION_REMOVED_OPERATION: string = "networkNodeOrganizationRemoveOperation";
    export const NETWORK_ORGANIZATION_ADDED_OPERATION: string = "networkOrganizationAddOperation";
    export const NETWORK_ORGANIZATION_REMOVED_OPERATION: string = "networkOrganizationRemoveOperation";
    export const GATEWAY_ORGANIZATION_ADDED_OPERATION: string = "gatewayOrganizationAddOperation";
    export const GATEWAY_ORGANIZATION_REMOVED_OPERATION: string = "gatewayOrganizationRemoveOperation";
    export const SON_NODE_CHANGED: string = "sonNodeChanged";
    export const SON_LINK_CHANGED: string = "sonLinkChanged";
    
    /* Flexo operations */
    export const DELETE_BLOCK_OPERATION: string = "deleteBlock";
    export const SAVE_BLOCK_OPERATION: string = "saveBlock";
    export const CREATE_BLOCK_OPERATION: string = "createBlock";
    export const DELETE_STREAM_PIPE_OPERATION: string = "deleteStreamPipe";
    export const SAVE_STREAM_PIPE_OPERATION: string = "saveStreamPipe";
    export const TAKE_OPERATION: string = "take";
    export const DROP_OPERATION: string = "drop";
    export const FAILED_STREAM_PIPE_OPERATION: string = "failedStreamPipe";
    export const CONFIRM_ALARM_OPERATION: string = "confirm";
    export const QUICK_SETTINGS_EXTERNALLY_OPERATION: string = "quickSettingsExternally";
    export const QUICK_SETTINGS_REQUESTED_OPERATION: string = "quickSettingsRequested";
    export const QUICK_SETTINGS_OPERATION: string = "quickSettings";
    export const LOGIN_OPERATION: string = "login";
    export const LOGOUT_OPERATION: string = "logout";
    export const IMPERSONATE_OPERATION: string = "impersonate";
    export const EXIT_IMPERSONATE_OPERATION: string = "exitImpersonate";
    export const LOGIN_FAILED_OPERATION: string = "loginFailed";
    export const LOCKED_BLOCK_OPERATION: string = "lockedBlock";
    export const UNLOCKED_BLOCK_OPERATION: string = "unlockedBlock";
    export const ADVANCED_SETTINGS_LOAD_OPERATION: string = "advancedSettingsLoad";
    export const ADMIN_SETTINGS_LOAD_OPERATION: string = "adminSettingsLoad";
    export const VIDEO_PLAY_OPERATION: string = "videoPlay";
    export const VIDEO_PLAY_ATTEMPT_OPERATION: string = "videoPlayAttempt";
    export const VIDEO_PLAY_ERROR_OPERATION: string = "videoPlayError";
    export const PROBE_OPERATION: string = "probe";
    export const UNPROBE_OPERATION: string = "unprobe";

    /* Node Health operations */
    export const HEALTH_CHANGED: string = "healthChanged";

    /* Conn room operations */
    export const CREATE_MONITOR_OPERATION: string = "createMonitor";
    export const SAVE_MONITOR_OPERATION: string = "saveMonitor";
    export const DELETE_MONITOR_OPERATION: string = "deleteMonitor";
    export const TRENDING_ON_OPERATION: string = "trendingOn";
    export const TRENDING_OFF_OPERATION: string = "trendingOff";
    export const CREATE_MONITOR_ROOM_OPERATION: string = "createMonitorRoom";
    export const DELETE_MONITOR_ROOM_OPERATION: string = "deleteMonitorRoom";
    export const SAVE_MONITOR_ROOM_OPERATION: string = "saveMonitorRoom";
    export const CREATE_MONITOR_PAGE_OPERATION: string = "createMonitorPage";
    export const DELETE_MONITOR_PAGE_OPERATION: string = "deleteMonitorPage";
    export const SAVE_MONITOR_PAGE_OPERATION: string = "saveMonitorPage";


    /* MobileData operations */
    export const SIM_USAGE_RECEIVED: string = "simUsage";

    /* Alarms operations */
    export const BULK_CONFIRM_OPERATION: string = "bulkConfirm";
    export const BULK_CONFIRM_ALL_OPERATION: string = "bulkConfirmAll";
    export const CREATE_ALARM_OPERATION: string = "create";

    /* Watchdog operations */
    export const SERVICE_UP_OPERATION: string = "serviceUp";
    export const SERVICE_DOWN_OPERATION: string = "serviceDown";

    /* User operations */
    export const USER_CREATED_OPERATION: string = "userCreate";
    export const USER_SAVED_OPERATION: string = "userSave";
    export const USER_ADDED_TO_GROUP: string = "userAddedToGroup";
    export const USER_ADDED_TO_ROLE: string = "userAddedToRole";
    export const USER_REMOVED_FROM_GROUP: string = "userRemovedFromGroup";
    export const USER_REMOVED_FROM_ROLE: string = "userRemovedFromRole";
    export const USER_REMOVED_FROM_ORGANIZATION: string = "userRemovedFromOrganization";

    /* Group operations */
    export const GROUP_CREATED_OPERATION: string = "groupCreate";
    export const GROUP_SAVED_OPERATION: string = "groupSave";
    export const GROUP_DELETED_OPERATION: string = "groupDelete";

    /* Organization operations */
    export const OPERATION_CREATE_ORGANIZATION: string = 'createOrganization';
    export const OPERATION_DELETE_ORGANIZATION: string = 'deleteOrganization';
    export const OPERATION_SAVE_ORGANIZATION: string = 'saveOrganization';

    /* Auth operations */
    // export const USER_SESSION_ENDED: string = 'userSessionEnded';
    export const USER_PERMISSIONS_MODIFIED: string = 'userPermissionsModified';

    export interface IFlexEvent {
        href?: string;
        userId?: string;
        id?: number;
        timestamp: string;
        component: string;
        operation: string;
        data: any; // tslint:disable-line
        visible: boolean;
    }

    export interface IBaseIdEventData {
        id: number;
    }

    export interface INetworkNodesEventData extends IBaseIdEventData {
        typeId: number;
    } 

    export interface ITakeEventData extends IDropEventData {
        source: number;
        sink: number;
        streamPipeId: number;
    }

    export interface IDropEventData { 
        source: number;
        sink: number;
        streamPipeId: number;
        pipeId: number;
    }

    export interface IStreamPipeSavedEventData { 
        id: number;
        sink: number;
        source: number;
        streamPipeId: number;
        active: boolean;
        errorCode: string;
        errorMessage: string;
    }

    export interface INetworkNodeOrganizationChangeEventData extends INetworkNodesEventData {
        organizationId: number;
        previousOrganizationId: number;
        mftSerialNumber: string;
        name: string;
        useSon: boolean;
        workflowMode: string;
    }

    export interface ISaveBlockEventData extends IBaseIdEventData {
        blockType: number;
        categories: string[];
        config: {
            serial: string;
        };
        locked: boolean;
        name: string;
        networkNodeHref: string;
        networkNodeTypeHref: string;
        connectionStatus?: BlockConnectionStatus;
    }

    export class FlexEvent implements IFlexEvent {
        public userId: string;
        public id: number;
        public timestamp: string;
        public component: string;
        public operation: string;
        /* tslint:disable */
        public data: any;
        /* tslint:enable */
        public visible: boolean;

        public static Empty(): FlexEvent {
            return new FlexEvent();
        }
    }
}

